import React from 'react';
import Image from 'next/image'
import {Container, Typography} from "@mui/material";
import LinkButton from "../../../atoms/LinkButton";
import colorPalette from "../../../../styles/theme/colorPalette";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import {css} from "@emotion/react";
import TeikiImage from '../../../../../public/images/shop/teiki/step5.jpg'

const Teiki = () => {
  return (
      <div css={wrapper}>
        <Container>
          <div css={{marginBottom: '32px'}}>
            <div css={{maxWidth: '160px', margin: '16px auto'}}>
              <Image src={TeikiImage}/>
            </div>
            <Typography variant={'h1'} css={mainTitle}>
              <span>栄養士おまかせ定期便</span>
            </Typography>
            <div css={subtitle}>
              数値改善された方の多くは<br/>
              「栄養士おまかせ定期便」をご利用されています。<br/>
              栄養士が食事指示の内容やご体調に合わせたご提案をいたします。
            </div>
            <div css={btnWrapper}>
              <LinkButton
                  text={'詳しく見る'}
                  href={'/teiki'}
                  maxWidth={"300px"}
                  hexColorCode={colorPalette.primary}
                  endAdornment={ <ArrowRightIcon /> }
                  css={btnStyle}
              />
            </div>
          </div>
        </Container>
      </div>
  );
};

export default Teiki;

const wrapper = css`
  padding: 24px 0;
  background-color: white;
`

const mainTitle = css`
  font-weight: bold;
  color: ${colorPalette.primary};
  padding: 1rem;
`

const subtitle = css`
  text-align: center;
  font-size: 1.8rem;
`

const btnWrapper = css`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`

const btnStyle = css`

`
